exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.divider[data-v-79ab3b94] {\n  height: 0.02667rem;\n  background-color: #3d3d42;\n}\n", "", {"version":3,"sources":["/Users/wuhm45/Documents/code/weex组件库/dolphin-weex-ui/packages/dof-divider/index.vue?cc0f523a"],"names":[],"mappings":";AAKA;EACA,mBAAA;EACA,0BAAA;CACA","file":"index.vue","sourcesContent":["<template>\n  <div class=\"divider\" :style=\"{ width: this.width ? this.width + 'px' : '100%' }\"></div>\n</template>\n\n<style scoped>\n.divider {\n  height: 2px;\n  background-color: #3d3d42;\n}\n</style>\n\n<script>\nexport default {\n  props: {\n    width: {\n      type: String,\n      default: ''\n    }\n  },\n  data: () => ({}),\n  created() {},\n  computed: {},\n\n  methods: {}\n}\n</script>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79ab3b94","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-divider/index.vue
// module id = 228
// module chunks = 0 1